import { useRouter } from 'next/router';
import { baseQueryParams } from 'src/utils';

/**
 * This hook is used to set the query parameters to the route
 * @returns {Function} setParamsToRoute
 */
export const useSetParamsToRoute = () => {
  const router = useRouter();

  const setParamsToRoute = (params: Partial<Record<keyof typeof baseQueryParams, string>>) => {
    const searchParams = new URLSearchParams();
    const path = router.query.path;
    const pathname = !path || typeof path === 'string' ? path : path.join('/');

    Object.entries(params).forEach(([key, value]) => {
      if (key && value) {
        searchParams.set(key, value);
      }
    });

    const parsedParams = decodeURIComponent(searchParams.toString());

    router.push(
      {
        pathname: pathname,
        query: parsedParams,
      },
      undefined,
      { scroll: false }
    );
  };

  return { setParamsToRoute };
};
